import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query client configuration
 * Configured with sensible defaults for caching and refetching
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for this duration
      gcTime: 30 * 60 * 1000, // 30 minutes - unused data is garbage collected after this duration
      retry: 3, // Retry failed requests 3 times
      refetchOnWindowFocus: true, // Refetch when window regains focus
      refetchOnReconnect: true, // Refetch when network reconnects
    },
    mutations: {
      retry: 1, // Retry failed mutations once
    },
  },
});
